/**
 * Markdown-light text converter.
 * @param {String} text
 * @return {String}
 */
export default (text: string): string => text.replace(/\*([^*]*)\*/, '<b>$1</b>')
